let swym_swat = null;
let default_list_id = null;
let wishlist_items = null;

const swymOnError = (error) => {
	console.error(`Error while fetching all Lists`, error);
  alert(`Error while adding the Product to the List: ${error}`);
};

const createDefaultList = (new_list) => {
  default_list_id = new_list.lid;
  swym_swat.fetchListDetails(default_list_id, listDetailsSuccess, swymOnError);
}

const listDetailsSuccess = (list_details) => {
  wishlist_items = list_details.items;

  const header = document.querySelector(`site-header`);
	const wishlist_count = header.querySelector(`[data-wishlist-count]`);

	if (list_details.items?.length > 0) {
		wishlist_count.classList.remove(`hidden`);
		wishlist_count.classList.add(`block`);
		wishlist_count.innerHTML = list_details.items.length;
	} else {
		wishlist_count.classList.remove(`block`);
		wishlist_count.classList.add(`hidden`);
		wishlist_count.innerHTML = ``;
	}

  const event = new CustomEvent("wishlist-items-updated");

  document.dispatchEvent(event);
};

const getListSuccess = (lists) => {
  if (lists.length === 0) {
    const list_config = {
      lname: `My Favorites`
    }

    swym_swat.createList(list_config, createDefaultList, swymOnError);
  } else {
    const default_list = lists.find(list => list.lname === `My Favorites`);

    default_list_id = default_list.lid;

    setTimeout(() => {
      swym_swat.fetchListDetails(default_list_id, listDetailsSuccess, swymOnError);
    }, 0);
  }
};

function onSwymLoadCallback (swat) {
	swym_swat = swat;

	swat.fetchLists({
		callbackFn: getListSuccess,
		errorFn: swymOnError,
	});
}

if (!window.SwymCallbacks) {
	window.SwymCallbacks = [];
}

window.SwymCallbacks.push(onSwymLoadCallback);